import { CaseAdmin, Clinic, Lab } from "pwapi";

import { LabList } from "custom-models/frontLoader";

import { useAppSelector } from "store/hooks";

export const useAllowsExternalAccession = ({
  clinic,
  grossed_by_external_lab_id,
  accessioning_lab,
  case_type,
}: {
  clinic?: Clinic;
  grossed_by_external_lab_id?: number;
  accessioning_lab?: Lab | LabList;
  case_type?: CaseAdmin.type;
}) => {
  const externalLab = useAppSelector(({ externalLabs }) =>
    externalLabs && externalLabs[grossed_by_external_lab_id || -1]
      ? externalLabs[grossed_by_external_lab_id || -1]
      : undefined
  );

  return (
    clinic?.name?.includes("Utah Valley Dermatology") ||
    (clinic?.name?.includes("Rocky Mountain Dermatology") &&
      case_type === CaseAdmin.type.TC_PC) ||
    externalLab?.name?.includes("Seacoast") ||
    externalLab?.name?.includes("Sutton Dermatology") ||
    accessioning_lab?.name?.toLowerCase().includes("propath") ||
    case_type === CaseAdmin.type.HISTORICAL ||
    accessioning_lab?.settings?.digital_pc?.active
  );
};
